import { ServerMessage } from '@/shared/types/server/response/server-message';
import { HttpStatusCode } from 'axios';
import { NextResponse } from 'next/server';

export class AppResponse {
  private _error = false;
  /**
   * Utiliza o mesmo padrão que os códigos de erro HTTP.
   */
  private _code: keyof typeof HttpStatusCode = 'Ok';
  private _tags: string[] = [];
  private _messages: ServerMessage[] = [];
  private _payload: { [key: string]: unknown } = {};

  public static build() {
    return new AppResponse();
  }

  public static isValid(appResponse: unknown) {
    if (
      appResponse &&
      typeof appResponse === 'object' &&
      'code' in appResponse &&
      'tags' in appResponse &&
      'messages' in appResponse &&
      'payload' in appResponse
    ) {
      return true;
    }

    return false;
  }

  public error(error: boolean) {
    this._error = error;
    return this;
  }
  public code(code: keyof typeof HttpStatusCode) {
    this._code = code;
    return this;
  }
  public tags(tags: string[]) {
    this._tags = tags;
    return this;
  }
  public messages(messages: ServerMessage[]) {
    this._messages = messages;
    return this;
  }
  public payload(payload: { [key: string]: unknown }) {
    this._payload = payload;
    return this;
  }

  public toNextResponse() {
    return NextResponse.json(this.toObject(), {
      status: HttpStatusCode[this._code],
    });
  }

  public toObject() {
    return {
      error: this._error,
      code: HttpStatusCode[this._code],
      tags: this._tags,
      messages: this._messages,
      payload: this._payload,
    };
  }
}
